import React from 'react';
import InputStyle from './Input.module.css' ;

const Input = React.forwardRef((props , ref) => {
  return (
    <div>
        <input ref={ref} type="text" id={props.input.id} {...props.input} className={InputStyle.input}/>
        <label htmlFor={props.input.id}>{props.label}</label>
    </div>
  )
})

export default Input;